// DAT-24 part B's provenance helper (TODO(DAT-24): DAT-24 part B owns this file
// and its sam_api / sam_extract / usaspending / opps_csv copy; DAT-25 created it
// first and adds sba_mp_xlsx). One label per public source, with staleness.
const DAY_MS = 24 * 60 * 60 * 1000;
const STALE_DAYS = {
    sam_extract: 45,
    opps_csv: 3,
    sba_mp_xlsx: 60
};
function parseDay(asOf) {
    if (!asOf) return null;
    if (asOf instanceof Date) return Number.isNaN(asOf.getTime()) ? null : asOf;
    const m = /^(\d{4})-(\d{2})-(\d{2})/.exec(asOf);
    if (m) return new Date(Date.UTC(Number(m[1]), Number(m[2]) - 1, Number(m[3])));
    const d = new Date(asOf);
    return Number.isNaN(d.getTime()) ? null : d;
}
/** "27 Oct" (UTC, so a date-only value never shifts a day). */ export function formatDayMonth(d) {
    return d.toLocaleDateString('en-GB', {
        day: 'numeric',
        month: 'short',
        timeZone: 'UTC'
    });
}
/** "27 Oct 2026" (UTC). */ export function formatDayMonthYear(d) {
    return d.toLocaleDateString('en-GB', {
        day: 'numeric',
        month: 'short',
        year: 'numeric',
        timeZone: 'UTC'
    });
}
export function formatPublicProvenance({ source, asOf, stale, now = new Date() }) {
    const d = parseDay(asOf);
    const when = d ? formatDayMonth(d) : 'unknown date';
    let label;
    switch(source){
        case 'sam_api':
            label = `SAM.gov · retrieved ${when}`;
            break;
        case 'sam_extract':
            label = `From SAM monthly extract, as of ${when}`;
            break;
        case 'usaspending':
            label = `From USAspending, retrieved ${when}`;
            break;
        case 'opps_csv':
            label = `From SAM.gov daily file, as of ${when}`;
            break;
        case 'sba_mp_xlsx':
            label = `From SBA's mentor-protégé list, as of ${when}`;
            break;
        default:
            label = `Public record, as of ${when}`;
    }
    const limit = STALE_DAYS[source];
    const ageDays = d ? Math.floor((now.getTime() - d.getTime()) / DAY_MS) : 0;
    const isStale = stale ?? (limit !== undefined && d !== null && ageDays > limit);
    if (!isStale) {
        return {
            label,
            tone: 'neutral',
            tooltip: label
        };
    }
    let tooltip;
    switch(source){
        case 'opps_csv':
            tooltip = `This daily file is ${ageDays} days old.`;
            break;
        case 'sba_mp_xlsx':
            tooltip = `SBA's mentor-protégé list here is ${ageDays} days old. SBA states no update schedule.`;
            break;
        default:
            tooltip = `This SAM.gov extract is ${ageDays} days old. A new one is published on the first Sunday of each month.`;
    }
    return {
        label: `${label} · may be out of date`,
        tone: 'warning',
        tooltip
    };
}
